import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { CurrencyProvider } from "./context/CurrencyContext";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import Landing from "./pages/Landing";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import PaymentSuccess from "./pages/PaymentSuccess";
import Track from "./pages/Track";
import Boxes from "./pages/Boxes";
import { FAQs, Shipping, Returns, Privacy, Terms, Support } from "./pages/StaticPages";
import Auth from "./pages/Auth";
import Account from "./pages/Account";
import AuthCallback from "./pages/AuthCallback";
import HowItWorks from "./pages/HowItWorks";
import About from "./pages/About";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import ScanResolve from "./pages/ScanResolve";
import ShopperRun from "./pages/ShopperRun";
import CategoryLanding from "./pages/CategoryLanding";
import PaymentCallback from "./pages/PaymentCallback";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname]);
  return null;
}

function Shell({ children }) {
  return (
    <>
      <Navbar />
      <main className="pb-24 lg:pb-0">{children}</main>
      <Footer />
    </>
  );
}

function OAuthGate({ children }) {
  const location = useLocation();
  if (location.hash && location.hash.includes("session_id=")) {
    return <Shell><AuthCallback /></Shell>;
  }
  return children;
}

function App() {
  return (
    <div className="App">
      <CurrencyProvider>
        <AuthProvider>
          <CartProvider>
            <BrowserRouter>
              <ScrollToTop />
              <Toaster position="top-center" richColors />
              <OAuthGate>
              <Routes>
                <Route path="/" element={<Shell><Landing /></Shell>} />
                <Route path="/shop" element={<Shell><Shop /></Shell>} />
                <Route path="/category/:name" element={<Shell><CategoryLanding /></Shell>} />
                <Route path="/product/:id" element={<Shell><ProductDetail /></Shell>} />
                <Route path="/cart" element={<Shell><Cart /></Shell>} />
                <Route path="/checkout" element={<Shell><Checkout /></Shell>} />
                <Route path="/payment/success" element={<Shell><PaymentSuccess /></Shell>} />
                <Route path="/payment/callback" element={<Shell><PaymentCallback /></Shell>} />
                <Route path="/track" element={<Shell><Track /></Shell>} />
                <Route path="/boxes" element={<Shell><Boxes /></Shell>} />
                <Route path="/subscriptions" element={<Navigate to="/boxes" replace />} />
                <Route path="/faqs" element={<Shell><FAQs /></Shell>} />
                <Route path="/shipping" element={<Shell><Shipping /></Shell>} />
                <Route path="/returns" element={<Shell><Returns /></Shell>} />
                <Route path="/privacy" element={<Shell><Privacy /></Shell>} />
                <Route path="/terms" element={<Shell><Terms /></Shell>} />
                <Route path="/support" element={<Shell><Support /></Shell>} />
                <Route path="/how-it-works" element={<Shell><HowItWorks /></Shell>} />
                <Route path="/about" element={<Shell><About /></Shell>} />
                <Route path="/login" element={<Shell><Auth /></Shell>} />
                <Route path="/register" element={<Shell><Auth /></Shell>} />
                <Route path="/account" element={<Shell><Account /></Shell>} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/s/:code" element={<ScanResolve />} />
                <Route path="/run/:token" element={<ShopperRun />} />
              </Routes>
              </OAuthGate>
            </BrowserRouter>
          </CartProvider>
        </AuthProvider>
      </CurrencyProvider>
    </div>
  );
}

export default App;
